var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.showRoutes)?_c('router-view',{key:_vm.$route.path}):_vm._e(),_vm._v(" "),(_vm.$store.state.loading)?_c('spinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }